"use client";
import { useMemo } from "react";

import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";
import { formatMessage } from "../../../utils/intl";
import ProductBarChart from "../ProductBarChart/ProductBarChart";
import {
  ProductBarChartTransaction,
  ProductBarChartValueFormatter,
} from "../ProductBarChart/types";
import { ViewType } from "../types";
import { Top5PropertiesRoomsNightsResult } from "./types";

type Props = {
  data: Top5PropertiesRoomsNightsResult;
  viewType?: ViewType;
  interactive?: boolean;
};

export default function HotelTopStayDuration({
  data,
  viewType,
  interactive,
}: Props) {
  const { CorporateTransactionDataAnalytics: cr } = useMobileContentResource();

  const transactions: ProductBarChartTransaction[] = useMemo(
    () =>
      data.top5PropertiesRoomsNights.transactions.map((t) => ({
        month: t.month,
        year: t.year,
        quarter: t.quarter,
        sortDate: t.roundedDownTransactionDate,
        entries: t.properties.map((p) => ({
          name: p.propertyName,
          value: Number(p.totalRoomNight),
        })),
      })),
    [data]
  );

  const valueFormatter: ProductBarChartValueFormatter = useMemo(
    () => ({
      formatYAxisTick: (v) => new Intl.NumberFormat("id-ID").format(v),
      formatTooltipValue: (v) => formatMessage(cr.nightUnit, { num: v }),
      emptyDomainMax: 10,
    }),
    [cr.nightUnit]
  );

  return (
    <ProductBarChart
      transactions={transactions}
      valueFormatter={valueFormatter}
      viewType={viewType}
      interactive={interactive}
    />
  );
}
